import PageLoading from '../../app/components/PageLoading';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { SETTINGS_PATHS } from '../settings/settingsPaths';
import { useLegacyMode } from './LegacyModeContext';

// Phase 1: Legacy stores use the same dashboard and pages as Native stores.
// The old legacy pages stay reachable by URL only.
// Old links to a settings tab hidden from Legacy stores open their first tab instead.
export const NativeSettingsRoute = ({ children }: { children: ReactNode }) => {
    const { loading, isLegacy } = useLegacyMode();
    if (loading) return <PageLoading />;
    return isLegacy ? <Navigate replace to={SETTINGS_PATHS.searchResults} /> : <>{children}</>;
};

const LegacyRouteGuard = ({ children }: { children: ReactNode }) => {
    const { loading, isLegacy } = useLegacyMode();
    if (loading) return <PageLoading />;
    return isLegacy ? <>{children}</> : <Navigate replace to="/dashboard" />;
};

export default LegacyRouteGuard;
